import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DetailsListModalComponent } from 'src/app/extensions/components/details-list-modal/details-list-modal.component';
import { PaymentAPIService } from 'src/app/extensions/services/api/payment-api.service';

@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.scss'],
  standalone: false,
})
export class PaymentDetailComponent implements OnInit {
  public constructor(
    private _activatedRoute: ActivatedRoute,
    private _paymentAPIService: PaymentAPIService,
    private _router: Router,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _ngbModal: NgbModal
  ) {}

  public paymentId: string;
  public payment: app.models.GetPaymentModel;
  public props: app.models.DynamicPropsDictionary;

  public hasData = true;

  public ngOnInit(): void {
    this.paymentId = this._activatedRoute.snapshot.params['paymentId'];

    this._paymentAPIService.getPayment(this.paymentId).subscribe(x => {
      this.payment = x.data;
      this.hasData = this.payment.invoices.length != 0;
      this.props = x.props;
    });
  }

  public backHandler() {
    this._router.navigate(['payments']);
  }

  showClipboardNotification() {
    this._notificationService.showSuccess(
      this._translateService.instant('common.copiedToClipboard'),
      this._translateService.instant('common.success')
    );
  }

  public openDetailsListModalInvoiceContracts = (e: Event, dataList: any[]) => {
    e.stopPropagation();
    const modal = this._ngbModal.open(DetailsListModalComponent, { backdrop: 'static', scrollable: true });
    modal.componentInstance.modalTitle = 'payment.detailsListModalTitle.contracts';
    modal.componentInstance.dataList = dataList.map(item => item.contractNumber);
  };
}
